export default class SolicitacaoService {
  constructor(resource) {
    this._resource = resource;
  }

  getSolicitacao(id, usuario) {
    return this._resource
      .post(`atendimento/solicitacao/${id}`, { usuario })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(err.body);
        }
      );
  }

  getSolicitacaoEmAberto(usuario) {
    return this._resource
      .get(`atendimento/solicitacao/em-aberto/${usuario}`)
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(err.body);
        }
      );
  }

  getSolicitacaoByServico(servicoId, usuarioId) {
    return this._resource
      .post("atendimento/solicitacao/by/servico", { servicoId, usuarioId })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(err.body);
        }
      );
  }

  getSolicitacaoConcluidos(usuario) {
    return this._resource
      .get(`atendimento/solicitacao/concluidos/${usuario}`)
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(err.body);
        }
      );
  }

  getSolicitacoesByFiltros({
    solicitacaoId,
    nomeRa,
    periodo,
    status,
    tipo,
    servico,
    statusProtocolo,
    etapas,
    etapaConcluida,
    usuarioId = null
  }) {
    if (servico) {
      servico = servico.map(s => s["value"]);
    }
    if (status) {
      status = status.map(s => s["value"]);
    }
    if (statusProtocolo) {
      statusProtocolo = statusProtocolo.map(s => s["value"]);
    }
    if (etapas) {
      etapas = etapas.map(s => s["value"]);
    }

    return this._resource
      .post("atendimento/solicitacao/by/responsavel", {
        solicitacaoId,
        nomeRa,
        periodo,
        status,
        tipo,
        servico,
        statusProtocolo,
        etapas,
        etapaConcluida,
        usuarioId
      })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(err.body);
        }
      );
  }

  saveSolicitacao(atendimento) {
    return this._resource.post("atendimento/solicitacao", { atendimento }).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error(err.body);
      }
    );
  }

  saveNewResposta(newResposta) {
    return this._resource.put("atendimento/solicitacao", { newResposta }).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error(err.body);
      }
    );
  }

  saveAvaliacao(avaliacao) {
    return this._resource.post("atendimento/avaliacao", { avaliacao }).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error(err.body);
      }
    );
  }

  encodeId(value) {
    const moment = require("moment");
    return btoa(
      `${moment().format("X")}_${value}_${Math.floor(Math.random() * 10000)}`
    );
  }

  decodeId(value) {
    let atendimentoId = atob(value);
    return atendimentoId.split("_")[1];
  }
}



// WEBPACK FOOTER //
// ./src/domain/atendimento/SolicitacaoService.js